import React, { useState, useEffect } from 'react';
import classNames from 'classnames'
import FieldError from './FieldError';

function StringField({field, displayErrors}) {

  const value = field.property[0];
  const placeholder = field.label + (field.required ? ' *': '')
  const onChange = (event) => field.property[1](event.target.value);
  const error = field.error[0];
  const lostFocus = useState(false);
  const onFocusLost = (event) => lostFocus[1](true);

  return (
    <div className="o-form-fieldset o-form-label-top">
      <div className={classNames('o-form-input', { 'o-form-has-errors': error })}>
        <span className={classNames('o-form-control','okta-form-input-field', 'input-fix', { 'o-form-has-errors': error })}>
          <input type="text" placeholder={placeholder} value={value} onChange={onChange} onBlur={onFocusLost} autoComplete="off"/>
        </span>
        {error && (lostFocus[0] || displayErrors) && (
          <FieldError msg={error}/>
        )}
      </div>
    </div>
    )
}

export default StringField;
